import Btn from '@app/lui2/Btn';
import FaIcon from '@app/lui3/FaIcon';

import {useRoamingSettings} from '../../RoamingSettingsContext';
import EmptyState from './EmptyState';

interface Props {
  agencyId: number;
}

const SyncEmail = ({agencyId}: Props) => {
  const {podUrl} = useRoamingSettings();

  const emailSyncUrl = `${podUrl}/agencies/${agencyId}/settings/email?tab=email_accounts`;

  return (
    <EmptyState
      title="Sync this Email"
      subtitle="You need to sync this email address in
Loxo to use this Microsoft add-in."
      actionButton={
        <Btn
          afterIcon={<FaIcon icon="arrow-up-right" size="sm" faStyle="solid" />}
          onClick={() => {
            window.open(emailSyncUrl, '_blank');
          }}
        >
          Sync Email in Loxo
        </Btn>
      }
    />
  );
};

export default SyncEmail;
